export default "__VITE_ASSET__BNXMpcZY__"